// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__-u+6z","overview":"footer_overview__G0RDV","social":"footer_social__RlCOB","socials":"footer_socials__GAsSp"};